import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { Action } from '@ngrx/store';
import { RmsContractBalance } from '@cemex-core/cmx-api';

import { createReducer, on } from '@ordersnproducts/utils/create-reducer';
import { AGREEMENTS_ACTION } from './agreements.action';

export interface Agreement {
  id: string;
  productCode: string;
  contractCode: string;
  balance: RmsContractBalance[];
  usedQuantity: number;
}

export interface State extends EntityState<Agreement> {
  selectedAgreementId: number;
}

export const adapter: EntityAdapter<Agreement> = createEntityAdapter<Agreement>({
  selectId: (_agreement) => _agreement.id,
  sortComparer: false,
});

const initialState: State = adapter.getInitialState({
  selectedAgreementId: null,
});

export const agreementsReducer = createReducer(
  initialState,

  on(AGREEMENTS_ACTION.FETCH_AGREEMENTS, (state, { productCode, contractCode }) => {
    return adapter.addOne(
      {
        id: productCode,
        productCode: productCode,
        contractCode: contractCode,
        balance: null,
        usedQuantity: 0,
      },
      state,
    );
  }),

  on(AGREEMENTS_ACTION.FETCH_AGREEMENTS_SUCCESS, (state, { balance, id }) => {
    return adapter.updateOne(
      {
        id: id,
        changes: {
          balance: balance,
        },
      },
      state,
    );
  }),

  on(AGREEMENTS_ACTION.FETCH_AGREEMENTS_FAILURE, (state, { error }) => {
    console.error(error);
    return state;
  }),

  on(AGREEMENTS_ACTION.UPDATE_AGREEMENT_BALANCE, (state, { id, totalAmount }) => {
    return adapter.updateOne(
      {
        id: id,
        changes: {
          usedQuantity: totalAmount,
        },
      },
      state,
    );
  }),
);

export function reducer(state: State | undefined, action: Action) {
  return agreementsReducer(state, action);
}
